export default {"src":"/_next/static/media/history.7d6a5a24.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};